import { useState } from 'react';
import { Download, Monitor, X } from 'lucide-react';

// Web-only: tells signed-in users there is a desktop app.
const DOWNLOAD_URL = 'https://www.chuckgiddens.com/email';
const DISMISS_KEY = 'dts.downloadBarDismissed';

function platformName(): string {
  const ua = navigator.userAgent;
  if (/Windows/i.test(ua)) return 'Windows';
  if (/Macintosh|Mac OS X/i.test(ua) && !/iPhone|iPad/i.test(ua)) return 'Mac';
  if (/Linux/i.test(ua) && !/Android/i.test(ua)) return 'Linux';
  return '';
}

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function DownloadBar() {
  const [hidden, setHidden] = useState(wasDismissed);
  const os = platformName();
  // Phones and tablets have no desktop build to offer.
  if (hidden || !os) return null;

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* storage blocked: hidden for this visit only */
    }
  };

  return (
    <div className="relative z-30 flex shrink-0 items-center gap-3 border-b border-line bg-accent/10 px-4 py-2 text-[13px]">
      <Monitor className="size-4 shrink-0 text-accent" />
      <span className="min-w-0 flex-1 truncate">
        <b className="font-semibold">DTS Mail is also a desktop app.</b>{' '}
        <span className="text-muted">Get new-mail notifications even with the browser closed, and open attachments in your own programs.</span>
      </span>
      <a
        href={DOWNLOAD_URL}
        target="_blank"
        rel="noopener"
        className="flex h-8 shrink-0 items-center gap-1.5 rounded-lg bg-accent px-3 text-[12.5px] font-semibold text-white transition hover:brightness-110"
      >
        <Download className="size-3.5" /> Download for {os}
      </a>
      <button onClick={dismiss} title="Dismiss" className="flex size-7 shrink-0 items-center justify-center rounded-lg text-muted transition hover:bg-line hover:text-fg">
        <X className="size-4" />
      </button>
    </div>
  );
}
